// Helper function to create content objects
export const createContent = (text: string) => ({
  raw: JSON.stringify({
    nodeType: 'document',
    data: {},
    content: [
      {
        nodeType: 'paragraph',
        data: {},
        content: [
          {
            nodeType: 'text',
            value: text,
            marks: [],
            data: {},
          },
        ],
      },
    ],
  }),
});

// Helper function to create content objects with darkGray color
export const createContentWithColor = (text: string) => ({
  raw: JSON.stringify({
    nodeType: 'document',
    data: {},
    content: [
      {
        nodeType: 'paragraph',
        data: {},
        content: [
          {
            nodeType: 'text',
            value: text,
            marks: [
              {
                type: 'color',
                attrs: {
                  color: 'tints.darkGrey',
                },
              },
            ],
            data: {},
          },
        ],
      },
    ],
  }),
});

// Helper function to create heading content
export const createHeadingContent = (text: string, level: number = 3) => ({
  raw: JSON.stringify({
    nodeType: 'document',
    data: {},
    content: [
      {
        nodeType: `heading-${level}`,
        data: {},
        content: [
          {
            nodeType: 'text',
            value: text,
            marks: [],
            data: {},
          },
        ],
      },
    ],
  }),
});

// Helper function to create testimonial quote
export const createTestimonialQuote = (text: string) => ({
  quote: {
    childMarkdownRemark: {
      rawMarkdownBody: text,
    },
  },
});

// Helper function to create long description text
export const createDescription = (text: string) => text;

// Helper function to create image object
export const createImage = (
  src: string,
  altText: string,
  width: number = 437,
  height: number = 300,
) => ({
  image: {
    gatsbyImageData: {
      layout: 'fixed' as const,
      width,
      height,
      images: { fallback: { src } },
    },
    description: altText,
  },
});

// Helper function to create video object
export const createVideo = (
  url: string,
  altText: string,
  height: string = '300px',
) => ({
  video: {
    file: {
      url,
      contentType: 'video/webm',
    },
    description: altText,
  },
  videoProps: {
    height,
  },
});

// Helper function to create benefit item
export const createBenefit = (id: string, title: string) => ({
  contentful_id: id,
  metadata: {
    context: {
      titleTag: null,
      iconName: null,
      iconColor: null,
      eyebrow: null,
      title,
    },
  },
});

// Helper function to create image data for benefits section
export const createBenefitsImage = (
  src: string,
  altText: string,
  width: number = 465,
  height: number = 564,
  mobileWidth: number = 360,
) => ({
  desktopImageAltText: altText,
  mobileImageAltText: altText,
  desktopImage: {
    gatsbyImageData: {
      layout: 'fixed' as const,
      width,
      height,
      images: {
        fallback: {
          src,
        },
      },
    },
  },
  mobileImage: {
    gatsbyImageData: {
      layout: 'constrained' as const,
      width: mobileWidth,
      height: Math.round((mobileWidth * height) / width),
      images: {
        fallback: {
          src,
        },
      },
    },
  },
  iconFile: null,
  desktopVideoFile: null,
  mobileVideoFile: null,
});

// Helper function to create step card with desktop and mobile images
export const createStepCard = (
  title: string,
  description: string,
  desktopAlt: string,
  mobileAlt: string,
) => ({
  title,
  description: createContentWithColor(description),
  desktopImage: {
    gatsbyImageData: {
      layout: 'fixed' as const,
      width: 1,
      height: 1,
      images: { fallback: { src: '' } },
    },
    description: desktopAlt,
  },
  mobileImage: {
    gatsbyImageData: {
      layout: 'fixed' as const,
      width: 1,
      height: 1,
      images: { fallback: { src: '' } },
    },
    description: mobileAlt,
  },
});
